import React from 'react';
import WeatherWidget from './WeatherWidget';
import TranslateWidget from './TranslateWidget';
import ExpressWidget from './ExpressWidget';
import HotSearchWidget from './HotSearchWidget';
import { AVAILABLE_WIDGETS } from '../../constants/presets';

const widgetMap = {
  weather: WeatherWidget,
  translate: TranslateWidget,
  express: ExpressWidget,
  hotsearch: HotSearchWidget,
};

const WidgetRenderer = ({ widgetType, size, widgetScale, title, globalWeatherData }) => {
  const WidgetComponent = widgetMap[widgetType];

  if (WidgetComponent) {
    return <WidgetComponent size={size} widgetScale={widgetScale} title={title} globalWeatherData={globalWeatherData} />;
  }

  // Fallback for unknown/in-development widgets
  let FoundIcon = null;
  AVAILABLE_WIDGETS.forEach(cat => {
    const found = cat.items.find(w => w.widgetType === widgetType);
    if (found && found.icon) FoundIcon = found.icon;
  });

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', opacity: 0.6, padding: `${1.2 * widgetScale}rem` }}>
      <h3 style={{ margin: 0, marginBottom: 'auto', fontSize: `${1.1 * widgetScale}rem`, fontWeight: 500, opacity: 0.9 }}>
        {title || '开发中'}
      </h3>
      <div style={{ marginBottom: '12px' }}>
        {FoundIcon && <FoundIcon size={48 * widgetScale} />}
      </div>
      <div style={{ fontSize: `${1 * widgetScale}rem` }}>该组件正在开发中</div>
    </div>
  );
};

export default WidgetRenderer;
